import * as THREE from 'three';

export abstract class Vehicle {
  protected mesh: THREE.Group;
  protected speed: number = 0;
  protected maxSpeed: number = 1;
  protected acceleration: number = 0.02;
  protected deceleration: number = 0.01;
  protected turnSpeed: number = 0.001;
  protected damping: number = 0.95;

  constructor() {
    this.mesh = new THREE.Group();
  }

  public getMesh(): THREE.Group {
    return this.mesh;
  }

  public abstract createModel(): void;

  public accelerate(): void {
    this.speed = Math.min(this.speed + this.acceleration, this.maxSpeed);
  }

  public brake(): void {
    this.speed = Math.max(this.speed - this.deceleration, -this.maxSpeed / 2);
  }

  public turnLeft(): void {
    this.mesh.rotation.y += this.turnSpeed;
  }

  public turnRight(): void {
    this.mesh.rotation.y -= this.turnSpeed;
  }

  public alignStraight(): void {
    this.mesh.rotation.set(0, 0, 0);
  }

  public update(): void {
    // Update position based on current speed and rotation
    const direction = new THREE.Vector3(0, 0, 1);
    direction.applyQuaternion(this.mesh.quaternion);
    direction.multiplyScalar(this.speed);
    this.mesh.position.add(direction);

    // Apply damping to smooth out speed changes
    this.speed *= this.damping;

    // Ensure speed does not go below a small threshold to avoid jittering
    if (Math.abs(this.speed) < 0.001) {
      this.speed = 0;
    }
  }
}